import React from 'react';
import { Loader2 } from 'lucide-react';

export default function PaymentStatus({ label = 'Processing your payment…' }) {
  return (
    <div className="pg-admin-card rounded-[var(--pg-radius-md)] p-8 text-center" data-testid="payment-processing">
      <Loader2 size={32} className="animate-spin text-[var(--pg-gold-2)] mx-auto" />
      <p className="text-sm text-[var(--pg-ink)] font-mono tracking-widest mt-4 uppercase">{label}</p>
      <p className="text-[11px] text-[var(--pg-ink-faint)] mt-1">Please don’t close this window.</p>
    </div>
  );
}
